import PageActionCreators from 'actions/framework/PageActionCreators';
import { SET_MY_CUSTOM_LIST } from 'constants/actionTypes/myLists';
import locationUtils from 'utils/Location';
import shoppingListApi from 'services/api/profile/shoppingList';
import { Pages } from 'constants/Pages';
import LoveActions from 'actions/LoveActions';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import PageTemplateType from 'constants/PageTemplateType';

class MyCustomListActionCreators extends PageActionCreators {
    isNewPage = () => true;

    updatePage = () => {};

    openPage = ({ events: { onPageUpdated, onDataLoaded, onError } }) => {
        return async (dispatch, getState) => {
            try {
                const { user, page, loves } = getState();
                const biAccountId = user?.beautyInsiderAccount?.biAccountId;
                const shoppingListId = locationUtils.getMyCustomListId();
                const sharedListToken = locationUtils.getSharedListToken();

                let data = {};
                let redirectTo404 = false;

                if ((shoppingListId && biAccountId && shoppingListId !== page.myCustomList?.shoppingListId) || loves.selectedCategories?.length > 0) {
                    Storage.local.removeItem(LOCAL_STORAGE.MY_CUSTOM_LIST_SCROLL_POSITION);

                    data = await shoppingListApi.getShoppingListById(biAccountId, shoppingListId, {
                        itemsPerPage: 60,
                        currentPage: 1,
                        includeCategories: true
                    });
                } else if (shoppingListId && biAccountId && shoppingListId === page.myCustomList?.shoppingListId) {
                    // use the existing myCustomList from state as cache
                    data = page.myCustomList;
                }

                if (sharedListToken) {
                    if (page.templateInformation?.template === PageTemplateType.ProductPage) {
                        data = page.myCustomList;
                    } else {
                        Storage.local.removeItem(LOCAL_STORAGE.MY_CUSTOM_LIST_SCROLL_POSITION);
                        data = await shoppingListApi.getSharedShoppingListByToken({
                            biAccountId,
                            sharedListToken,
                            options: {
                                itemsPerPage: 60,
                                currentPage: 1,
                                includeCategories: true
                            }
                        });
                    }

                    data = data?.loves ? data.loves : data;

                    // redirecting to 404 if the shared list has no ID, meaning is not found
                    if (data.isSharedList && !data.shoppingListId) {
                        redirectTo404 = true;
                    }
                }

                if (redirectTo404) {
                    onError(true, { path: Pages.Error404 }, true);
                }

                dispatch(LoveActions.setCategoriesFilter([]));
                onDataLoaded(data);
                dispatch({
                    type: SET_MY_CUSTOM_LIST,
                    payload: data
                });
                dispatch(LoveActions.setLoveListName(data.shoppingListName || ''));

                onPageUpdated(data);

                return Promise.resolve();
            } catch (error) {
                onError(error);

                return Promise.reject(error);
            }
        };
    };
}

const MyCustomListPageActions = new MyCustomListActionCreators();

export default MyCustomListPageActions;
